import React, { Fragment } from 'react'
import { faExternalLinkAlt, FontAwesomeIcon, styled } from '../../utilities'
import modules from './link.module.scss'
import withTheme from '../hoc/withTheme'

const StyledLink = styled.a`
  ${(props = {}) => {
      const { theme = {} } = props
      return {
        color: theme.action
    }
  }}
`;

const externalLinkProps = {
  target: '_blank',
  rel: 'noopener noreferrer'
}

const ExternalLink = (props = {}) => {
    const { content, href, children, ...rest } = props
    let formattedHref = href
    let addedProps = {}
    const domains = ['org', 'com', 'net', 'edu', 'gov']
    let phoneNumber = href.startsWith('tel:')
    let email = href.startsWith('mailto:')
    let fallback = !href.startsWith('http') && (href.startsWith('www.') || domains.some(domain => href.includes(`.${domain}`)))
    const external = (href.startsWith('http') || fallback) && !phoneNumber && !email

    if(external) {
      addedProps = {
        ...addedProps,
        ...externalLinkProps
      }
      if(fallback) {
        formattedHref = `//${href}`
      }
    }

    return (
      <StyledLink
        href={formattedHref}
        {...addedProps}
        {...rest}
      >
        {children}
        {external && (
          <Fragment>
            <span className="sr-only">&nbsp;(link is external)</span>
            <FontAwesomeIcon
              className={modules.externalIcon}
              size="xs"
              aria-hidden
              icon={faExternalLinkAlt}
            />
          </Fragment>
        )}
      </StyledLink>
    );
}

export default withTheme(ExternalLink)